import React, { useState, useMemo } from 'react';
import { Accordion } from 'react-bootstrap';
import cx from 'classnames';
import { injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import Link from '../Link/Link';
import messages from '../../locale/messages';
import { DownArrowIcon } from '../Common/Assets/SVGIcon/SiteAdminIcon';
import s from './SideMenuAccordion.css';


function SideMenuAccordion({ label, intl, dataValue, isActive, icon, location, handleMobileMenu }) {
    const [toggle, setToggle] = useState(false);
    const { formatMessage } = intl;

    return (
        <div>
            <Accordion className={s.sideMenuAccordionHeader}>
                <Accordion.Toggle eventKey="0" onClick={() => setToggle(!toggle)} className={cx(s.sideMenuAccordionHeaderBtn, ((isActive) && s.sideMenuAccordionHeaderActiveBtn))}>
                    <span className={s.sideMenuItemIconContainer}>
                        {icon}
                    </span>
                    <span className={s.sideMenuAccordionItemTextContainer}>
                        {formatMessage(messages[label])}
                    </span>
                    <span className={cx(s.sideMenuAccordionItemArrow, toggle && s.sideMenuAccordionItemActiveArrow)}>
                        <DownArrowIcon />
                    </span>
                </Accordion.Toggle>

                <Accordion.Collapse eventKey="0">
                    <div>
                        {dataValue.map((item, index) => {
                            let isMenuActive = false;
                            if (item?.activePaths?.length > 0 && location) {
                                isMenuActive = item.activePaths.some(path => location?.startsWith(path) && path !== '/siteadmin');
                            }
                            return (<Link key={index} to={item?.href} className={cx(s.sideMenuAccordionCollapseItem, ((item.href == location || isMenuActive) && s.sideMenuAccordionCollapseItemActive))} onClick={handleMobileMenu && handleMobileMenu}>
                                <span className={cx(s.sideMenuAccordionCollapseItemIcon, 'sideMenuAccordionCollapseItemIconRtl')}>{item?.icon}</span>
                                <span className={s.sideMenuAccordionCollapseItemText}>{item?.label && formatMessage(messages[item?.label])}</span>
                            </Link>)
                        })}
                    </div>
                </Accordion.Collapse>
            </Accordion>
        </div>
    );
}

export default injectIntl(withStyles(s)(SideMenuAccordion));